import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, Renderer } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { LlamadasComponent } from 'app/modals/cartera/llamadas/llamadas.component';
import { TipoFacturaComponent } from 'app/modals/cartera/tipo-factura/tipo-factura.component';
import { DebitoAutoComponent } from 'app/modals/cartera/debito-auto/debito-auto.component';
import { VerCobroComponent } from 'app/modals/cartera/ver-cobro/ver-cobro.component';
import * as moment from 'moment';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { BusquedaXNombreComponent } from 'app/modals/cartera/busqueda-x-nombre/busqueda-x-nombre.component';
import { BitacoraGrupoComponent } from 'app/modals/cartera/bitacora-grupo/bitacora-grupo.component';
import { TotalServiciosGrupoComponent } from 'app/modals/cartera/total-servicios-grupo/total-servicios-grupo.component';
import { LlamadasBitacoraComponent } from 'app/modals/cartera/llamadas-bitacora/llamadas-bitacora.component';
import { HistorialCobrosComponent } from 'app/modals/cartera/historial-cobros/historial-cobros.component';
import { BitacoraRetirosComponent } from 'app/modals/cartera/bitacora-retiros/bitacora-retiros.component';
import { FacturasAtrasadasComponent } from 'app/modals/cartera/facturas-atrasadas/facturas-atrasadas.component';
import { HistoricoFacturasComponent } from 'app/modals/cartera/historico-facturas/historico-facturas.component';
import { SmsProgramarCobroComponent } from 'app/modals/cartera/sms-programar-cobro/sms-programar-cobro.component';
import { ObservacionCarteraGrupoComponent } from 'app/modals/cartera/observacion-cartera-grupo/observacion-cartera-grupo.component';
import { InformacionCobro } from 'app/entities/cobranza';
import { Title } from '@angular/platform-browser';
import { BeneficiariosXGrupoComponent } from 'app/modals/cartera/beneficiarios-x-grupo/beneficiarios-x-grupo.component';
import { AsociarRadicadoComponent } from 'app/modals/cartera/asociar-radicado/asociar-radicado.component';


@Component({
  selector: 'app-programar-cobros',
  templateUrl: './programar-cobros.component.html',
  styleUrls: ['./programar-cobros.component.scss']
})
export class ProgramarCobrosComponent implements OnInit, OnDestroy, AfterViewInit {

  // Variables //
  public documento: string;
  public radicado: string;
  public codigo: string;
  public empresa: {
    nombre: string,
    base_datos: string,
    indice_empresa: string,
    tp_contrato?: string,
    tarifa?:string,
    grugru?:string
  }
  public hora_actual: any = moment();
  public isNull_Grupo = false;
  public select_tab = 1;
  public select_toggleGroup = '0';
  private array_radicados: Array<string> = [];

  // Variables DataTable //
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  /**
   * Constructor
   *
   * @param {MatDialog} _dialog
   * @param {MatSnackBar} _snackBar
   * @param {Router} _router
   * @param {CarteraService} _cartera
   * @param {Title} _title
   */
  constructor
  (
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _cartera: CarteraService,
    private _title: Title
  )
  {
    this._title.setTitle('VitalSoft - Programar Cobros Ocasionales'); // Título de la pestaña //
    this.empresa = {
      nombre: 'Red Médica Vital',
      base_datos: 'medisoft',
      indice_empresa: '1'
    }
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.tableOpt = [];
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit(): void {

    this.dtOptions = {
      responsive: true,
      language: {
        lengthMenu: `Número de _MENU_ registros por página`,
        zeroRecords: `Datos no encontrados - Lo sentimos`,
        info: `Mostrando la página _PAGE_ de _PAGES_`,
        infoEmpty: `No hay registros disponibles`,
        infoFiltered: `(Filtrado de _MAX_ registros totales)`,
        LoadingRecords: `Cargando...`,
        search: `Buscar:`,
        paginate: {
          first:   `Primero`,
          last:    `Último`,
          next:    `Siguiente`,
          previous:`Anterior`
        }
      },
      columns: [
        {},
        {
          render: (data, type, row, meta) =>{
            return `<a>${data}</a>`
          }
        },
        {
          render: (data, type, row, meta) =>{
            return `<a>${data}</a>`
          }
        },
        {
          data: `beneficiarios_activos`
        },
        {
          data: `ciclo_grupo`
        },
        {
          render: (data, type, row, meta) =>{
            return `<a>${data}</a>`;
          }
        },
        /* {
          render: (data, type, row, meta) => {
            return `<a>${data}</a>`;
          }
        }, */
        {
          render: (data, type, row, meta) => {
            return `<a>${data}</a>`;
          }
        },
        {
          data: `nvo_saldo`
        },
        {
          render: (data, type, row, meta) => {
            return `<a>${data}</a>`;
          }
        },
        {
          data: `meses_afiliacion`
        },
        {},
        {
          render: (data, type, row, meta) => {
            return `<a style="color: ${data == '2'? '#000000' : '#FFFFFF'}">${data}</a>`;
          }
        },
        {
          render: (data, type, row, meta) => {
            return `<a style="color: ${data == '2'? '#000000' : '#FFFFFF'}">${data}</a>`;
          }
        },
        {
          data: `estado_grupo`
        }
      ]
    }

    this.radicadosxEmpresa(this.empresa.base_datos);
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Función que vuelve las variables documento y radicado undefined, para que no produzca
   * errores a la hora de ejecutar la búsqueda
   */
  public clicTab(): void{
    this.documento = undefined;
    this.radicado = undefined;
  }

  /**
   * Función donde se realizan filtros antes de buscar el grupo, si uno de estos filtros se
   * cumple, realiza un return, de lo contrario, ejecuta 'mostrarInfoGrupo'
   */
  public buscarGrupo(): void{
    const regExr = /[^A-Za-z0-9]/g;

    // Condición: Si la variable documento cumple con la expresión regular, realiza un return; //
    if(regExr.test(this.documento)){
      this._snackBar.open('Error: Datos Inválidos', '', {
        panelClass: ['warn-600'],
        duration: 2000
      });
      return;
      // Condición: Si la variable radicado cumple con la expresión regular, realiza un return; //
    }else if(regExr.test(this.radicado)){
      this._snackBar.open('Error: Datos Inválidos', '', {
        panelClass: ['warn-600'],
        duration: 2000
      });
      return
    }

    // Condición: si las variables documento y radicado estan vacias, realiza un return; //
    if(!this.documento && !this.radicado){
      this._snackBar.open('Error: Campo Requerido', '', {
        panelClass: ['warn-600'],
        duration: 2500
      });
      return;
    }

    // Si ninguna de las condiciones se cumple se ejecuta esta función //
    this.mostrarInfoGrupo();
  }

  /**
   * Función encargada de asignar valores a la variable empresa, dependiendo de la variable opción
   * ejecuta 'radicadosxEmpresa'
   * @param {string} opcion
   */
  public seleccionarEmpresa(opcion: string): void{

    this.select_toggleGroup = opcion;

    this.empresa = {
      nombre: opcion === '1' ? 'VitalMascotas' : 'Red Médica Vital',
      base_datos: opcion === '0' ? 'medisoft' : 'medisoftvet',
      indice_empresa: opcion === '0' ? '1' : '2'
    }

    this.radicadosxEmpresa(this.empresa.base_datos);
  }

  /**
   * Realiza la búsqueda de Radicados
   * @param {string} database
   */
  public radicadosxEmpresa(database: string): void{
    // Se vacia el arreglo array_radicados //
    this.array_radicados.splice(0, this.array_radicados.length);

    this._cartera.VerRadicados(database).subscribe((data: Array<{radicado: string}>) => {
      // se llena el arreglo array_radicados //
      data.forEach(element => {
        this.array_radicados.push(element.radicado);
      });
    });
  }

  /**
   * Cambia el valor de la variable radicado dependiendo de la opción, ejecuta 'mostrarInfoGrupo'
   * @param {string} opcion
   */
  public changeRadicado(opcion: string): void{
    const Position: number = this.array_radicados.indexOf(this.radicado);
    switch (opcion) {
      case 'first':
        this.radicado = this.array_radicados[0];
        this.mostrarInfoGrupo();
        break;
      case 'before':
        this.radicado = this.array_radicados[Position - 1];
        this.mostrarInfoGrupo();
        break;
      case 'next':
        this.radicado = this.array_radicados[Position + 1];
        this.mostrarInfoGrupo();
        break;
      case 'last':
        this.radicado = this.array_radicados[this.array_radicados.length - 1];
        this.mostrarInfoGrupo();
        break;
    }
  }

  /**
   * Enruta al calendario, para su respectiva asignación del cobro
   * @param {string} grunit
   * @param {string} grugru
   * @param {string} rad_asociado
   */
  public onRouterAgendaCobro(grunit: string, grugru: string, rad_asociado: string): void {
    this._router.navigate(['cobranza/cartera/cobros-ocasionales/agenda-calendario', 'ocasionales', this.empresa.indice_empresa, this.empresa.base_datos, this.codigo ]);
    localStorage.setItem('Grupo', JSON.stringify({Documento: grunit, Radicado: grugru, Rad_Asociado: rad_asociado}));
  }

  /**
   * Muestra la información del grupo consultado
   */
  mostrarInfoGrupo(): void{
    this._cartera.VerInfoGrupo(this.radicado, this.documento, this.empresa.base_datos).subscribe((data: any) => {
      if(data.length){
        this.renderer();
        this.tableOpt = data;
        if(this.documento){
          this.codigo = this.documento;
        }else{
          this.codigo = this.radicado;
        }
        this.empresa.tp_contrato = data[0].tipo_contrato;
        this.empresa.tarifa = data[0].tarifa;
        this.empresa.grugru = data[0].grugru;
        this.isNull_Grupo = false;
      }else{
        this.isNull_Grupo = true;
      }
    });
  }

  /**
   * Renderiza la tabla
   */
  renderer(): void{
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    })
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Modals
  // -----------------------------------------------------------------------------------------------------

  /**
   * Abre el modal Llamada, encargado de registrar una llamada al grupo anteriormente consultado,
   * al cerrarse y si devuelve una variable verdadera, ejecuta 'mostrarInfoGrupo'
   */
  public modalLlamada(): void{
    let modal;
    modal = this._dialog.open(LlamadasComponent, {
      width: '63%',
      height: '100%',
      panelClass: 'custom-dialog-container',
      data: {
        data_base: this.empresa.base_datos,
        indice: this.empresa.indice_empresa,
        grunit: this.tableOpt[0].codigo_grupo,
        grugru: this.tableOpt[0].radicado_grupo,
        grugru_asociado: this.tableOpt[0].rad_asociado,
        hora: this.hora_actual.format('HH:mm:ss'),
        search_code: this.codigo,
        origen: 'ocasionales'
      }
    });
    modal.afterClosed().subscribe((result: boolean) => {
      // Condición: si result es verdadero, ejecuta 'mostrarInfoGrupo' //
      if(result) this.mostrarInfoGrupo();
    });
  }

  /**
   * Abre el modal Historial Cobros, encargado de mostrar el historial de cobros del grupo en cuestión
   * @param {string} grunit
   * @param {string} grugru
   */
  public modalHistorialCobros(grunit: string, grugru: string): void{
    this._dialog.open(HistorialCobrosComponent, {
      maxWidth: '93vw',
      data: {
        grunit: grunit,
        grugru: grugru,
      }
    });
  }

  /**
   * Abre el modal BusquedaxNombre, encargado de la búsqueda por el nombre del grupo,
   * cuando no se tiene conocimiento del radicado ó del documento, al cerrarse,
   * devuelve un radicado y una empresa
   */
  public modalBusquedaxNombre(): void{
    let modal;
    modal = this._dialog.open(BusquedaXNombreComponent, {
      width: '40vw'
    });
    modal.afterClosed().subscribe((result: any) => {
      this.empresa = {
        nombre: result.empresa == '0'? 'Red Médica Vital' : 'VitalMascotas',
        base_datos: result.empresa == '0'? 'medisoft' : 'medisoftvet',
        indice_empresa: result.empresa == '0'? '1' : '2'
      }
      this.select_toggleGroup = result.empresa;
      this.select_tab = 1;
      this.radicado = result.radicado;
    });
  }

  /**
   * Abre modal TipoFactura, encargado de la visualización y la modificación del tipo de factura del
   * grupo en cuestión, al cerrarse, si devuelve una variable verdadera, ejecuta 'mostrarInfoGrupo'
   */
  public modalTipoFactura(): void {
    let modal: any;
    modal = this._dialog.open(TipoFacturaComponent, {
      width: `26%`,
      data: {
        empresa: this.empresa.base_datos,
        codigo: this.codigo,
        factura_fis: this.tableOpt[0]['factura_fisica'],
        factura_elec: this.tableOpt[0]['factura_elec']
      }
    });
    modal.afterClosed().subscribe((result: any) => {
      // Condición: si result es verdadero, ejecuta 'mostrarInfoGrupo' //
      if(result) this.mostrarInfoGrupo();
    });
  }

  /**
   * Abre modal BitacoraGrupo, encargado de mostrar la bitácora del grupo en cuestión
   */
  public modalBitacoraGrupo(): void {
    this._dialog.open(BitacoraGrupoComponent, {
      data: {
        base_datos: this.empresa.base_datos,
        search_code: this.codigo
      }
    });
  }

  /**
   * Abre modal TotalServicios, encargado de mostrar todos los servicios del grupo en cuestión
   */
  public modalTotalServicios(): void {
    this._dialog.open(TotalServiciosGrupoComponent, {
      data: {
        base_datos: this.empresa.base_datos,
        search_code: this.codigo
      }
    });
  }

  /**
   * Abre modal HistoriaLlamadas, encargado de mostrar el historial de llamada del grupo
   */
  public modalHistoriaLlamadas(): void {
    this._dialog.open(LlamadasBitacoraComponent, {
      data: {
        id_grupo: this.tableOpt[0].id_grupo
      }
    });
  }

  /**
   * Abre modal BitacoraRetiros, encargado de mostrar la cantidad de retiros del grupo, y mostrar su bitácora
   */
  public modalBitacoraRetiros(): void {
    this._dialog.open(BitacoraRetirosComponent, {
      data: {
        base_datos: this.empresa.base_datos,
        search_code: this.codigo,
        info_grupo: {
          grunit: this.tableOpt[0].codigo_grupo,
          grugru: this.tableOpt[0].radicado_grupo,
          grunom: this.tableOpt[0].nombre_grupo,
          cant_retiro: this.tableOpt[0].cant_retiros
        }
      }
    });
  }

  /**
   * Abre modal FacturasAtrasadas, encargado de mostrar la cantidad de facturas atrasadas y la información sobre estas
   */
  public modalFacturasAtrasadas(): void {
    this._dialog.open(FacturasAtrasadasComponent, {
      data: {
        base_datos: this.empresa.base_datos,
        info_grupo : {
          grunit: this.tableOpt[0].codigo_grupo,
          grugru: this.tableOpt[0].radicado_grupo,
          grunom: this.tableOpt[0].nombre_grupo,
          cant_atraso: this.tableOpt[0].cant_retraso
        }
      }
    });
  }

  /**
   * Abre modal HistoricoFacturas, encargado de mostrar el historico de facturas del grupo
   */
  public modalHistoricoFacturas(): void {
    this._dialog.open(HistoricoFacturasComponent, {
      data: {
        grunit: this.tableOpt[0].codigo_grupo,
        grugru: this.tableOpt[0].radicado_grupo,
        base_datos: this.empresa.base_datos
      }
    });
  }

  /**
   * esta funcion abre el modal de sms de programar cobros y
   * manda por parametros los datos (numero,telefono,radicado,grupo,factura) del radicado
   * mostrado en la tabla
   */
  public smscobros():void {
     this._dialog.open(SmsProgramarCobroComponent,{
       width:'70%',
       data:{
         numero: this.tableOpt[0].celular_grupo,
         telefono: this.tableOpt[0].telefono_grupo,
         radicado: this.tableOpt[0].radicado_grupo,
         grupo: this.tableOpt[0].id_grupo,
         factura: this.tableOpt[0].factura_fisica,
         empresa:this.tableOpt[0].empresa
       }
     })
  }

  /**
   * Abre modal ObservacionCarteraGrupo, encargado de la visualización y modificación de las observaciones del grupo
   * @param {string} grunit
   * @param {string} grugru
   */
  public modalObservacionesGrupo(grunit: string, grugru: string){
    this._dialog.open(ObservacionCarteraGrupoComponent, {
      width: '30%',
      height: '70%',
      data: {
        grunit: grunit,
        grugru: grugru,
        base_datos: this.empresa.base_datos
      }
    });
  }

  /**
   * Abre modal Beneficiarios, encargado de mostrar el historial de beneficiarios
   * @param {string} grunit
   * @param {string} grugru
   */
  public modalBeneficiarios(grunit: string, grugru: string){
    this._dialog.open(BeneficiariosXGrupoComponent, {
      maxWidth: '93vw',
      data: {
        Documento: grunit,
        Radicado: grugru,
        empresa:this.empresa.indice_empresa === "1"? 'rmv':'vm' 
      }
    });
  }

  /**
   * Abre modal RadicadoAsoc, encargado de la búsqueda del grupo del cual se desea asociar el radicado
   * al grupo en cuestión, al cerrarse, se devuelve el radicado a asociar.
   * @param {string} radicado
   */
  public modalRadicadoAsoc(radicado: string): void {
    const Database: string = this.empresa.base_datos === 'medisoft' ? 'medisoftvet' : 'medisoft';
    let asociar_Radicados: Array<{Database: string, Radicado: string, Rad_asoc: string}> = []

    let modal: any;
    modal = this._dialog.open(AsociarRadicadoComponent, {
      width: '40vw',
      data: {
        Database: Database
      }
    });

    modal.afterClosed().subscribe((radicado_asoc: string) => {
      // Condición: Si radicado_asoc existe //
      if(radicado_asoc){
        asociar_Radicados.push({
          Database: this.empresa.base_datos,
          Radicado: radicado,
          Rad_asoc: radicado_asoc
        },
        {
          Database: Database,
          Radicado: radicado_asoc,
          Rad_asoc: radicado
        });
        this._cartera.AgregarRadicadoAsoc(asociar_Radicados).subscribe((data: any) => {
          if(data['changedRows'] > 0 && data['affectedRows'] >= 1){
            this._snackBar.open(`Radicado Asociado`, 'Aceptar', {
              duration: 2000
            });
          }else if(data['changedRows'] === 0 && data['affectedRows'] >= 1){
            this._snackBar.open('Radicado ya asociado', '', {
              duration: 2500,
              panelClass: 'yellow'
            });
          }else{
            this._snackBar.open('Error al asociar el radicado', '', {
              duration: 2500,
              panelClass: 'warn-600'
            });
          }
        });
      }
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Disabled Functions: Funciones obsoletas con la nueva versión
  // -----------------------------------------------------------------------------------------------------

  /* public modalVerCobro(grunit: string, grugru: string): void{
    this._cartera.verUltimoCobro(this.empresa.base_datos, grunit, grugru).subscribe((data: any) => {
      if(!data){
        this._snackBar.open('Cliente sin cobros existentes', 'x', {
          duration: 2000,
          panelClass: 'yellow'
        });
        return;
      }else{
        this._dialog.open(VerCobroComponent, {
          width: '63%',
          height: '100%',
          panelClass: 'custom-dialog-container',
          data: {
            grunit: this.tableOpt[0].codigo_grupo,
            data_base: this.empresa.base_datos,
            grugru: this.tableOpt[0].radicado_grupo,
            ciclo: this.tableOpt[0].ciclo_grupo,
            estado: this.tableOpt[0].estado_grupo,
            nvo_saldo: this.tableOpt[0].nvo_saldo,
            nombre: this.tableOpt[0].nombre_grupo,
            id_grupo: this.tableOpt[0].id_grupo
          }
        });
      }
    });
  } */

  /* public modalDebitoAuto(): void {
    let modal: any;
    modal = this._dialog.open(DebitoAutoComponent, {
      width: `26%`,
      data: {
        empresa: this.empresa.base_datos,
        codigo: this.codigo,
        debitoAuto: this.tableOpt[0]['Debito_automatico'],
      }
    });
    modal.afterClosed().subscribe((result:any) => {
      if(result){
        this.mostrarInfoGrupo();
      }
    });
  } */
}


